export default "/images/acbe01d6c97473770b4343eab8f1e883.avif";